import { compose, configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './reducers';
import rootSaga from './sagas';

const sagaMiddleware = createSagaMiddleware();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const preloaded = window.__PRELOADED_STATE__ || {};

export default function configureReduxStore() {
    const store = configureStore({ reducer: rootReducer, preloadedState: preloaded, middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleware) });
    sagaMiddleware.run(rootSaga);

    return store;
}